import FirstName from './first-name';
import MiddleName from './middle-name';
import LastName from './last-name';
import FullName from './full-name';
import Bio from './bio';
import Image from './image';
import BarAdmissions from './bar-admissions';
import ClassesSeminars from './classes-seminars';
import Education from './education';
import Honors from './honors';
import Location from './location';
import LocationText from './location-text';
import Phone from './phone';
import Fax from './fax';
import Email from './email';
import PracticeAreas from './practice-areas';
import ProfessionalAssociation from './professional-association';
import PublishedWorks from './published-works';
import PastPositions from './past-positions';
import ProBonos from './pro-bonos';
import Languages from './languages';
import FraternitySororities from './fraternity-sororities';
import References from './references';
import RepresentativeCases from './representative-cases';
import Specialties from './specialties';
import AncillaryBusinesses from './ancillary-businesses';
import CurrentPositions from './current-positions';
import RepresentativeClients from './representative-clients';

export default {
	first_name: FirstName,
	middle_name: MiddleName,
	last_name: LastName,
	full_name: FullName,
	bio: Bio,
	profile_image: Image,
	bar_admissions: BarAdmissions,
	classes_seminars: ClassesSeminars,
	education: Education,
	honors: Honors,
	location: Location,
	location_text: LocationText,
	phone: Phone,
	fax: Fax,
	email: Email,
	practice_areas: PracticeAreas,
	professional_assoc: ProfessionalAssociation,
	published_works: PublishedWorks,
	past_positions: PastPositions,
	pro_bonos: ProBonos,
	languages: Languages,
	fraternity_sororities: FraternitySororities,
	representative_cases: RepresentativeCases,
	specialties: Specialties,
	references: References,
	ancillary_businesses: AncillaryBusinesses,
	current_positions: CurrentPositions,
	representative_clients: RepresentativeClients,
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/parts-map.js